<template>
  <div class="coupon-item-wrap">
    <div class="coupon-item">
      <div class="content-wrapper">
        <div class="value-wrapper">
          <div class="value-label">
            <coupon-value-label textColor="#ffffff" :couponData='couponData' :couponValue='couponData.couponValue' :couponType='couponData.couponType'></coupon-value-label>
            <p class="value-tips" v-if="couponData.couponType !== 'REALITY_GIFT_COUPON'">{{couponData.description}}</p>
          </div>
          <!-- <img class="value-tag" :src="`${$cdnImageUrl}/voucher/quan_pingtai.png`" alt=""> -->
          <img v-if="couponData.couponUseType === 'SHOP'" class="value-tag" :src="`${$cdnImageUrl}/voucher/quan_dianpu.png`" alt="">
          <img v-if="couponData.couponUseType === 'ORDER' && couponData.couponType !== 'REALITY_GIFT_COUPON'" class="value-tag value-tag-pingtai" :src="`${$cdnImageUrl}/voucher/quan_pingtai.png`" alt="">
          <!-- <img v-if="couponData.couponType === 'REALITY_GIFT_COUPON'" class="value-tag value-tag-small value-tag-gift" :src="`${$cdnImageUrl}/voucher/quan_lipin_purple.png`" alt=""> -->
          <div v-if="couponData.couponType === 'REALITY_GIFT_COUPON'" class="value-tag value-tag-gift-label"><span>礼品券</span></div>
          <img v-if="couponData.marking === 'sheng'" class="value-tag-quan" :src="`${$cdnImageUrl}/goodsDetail/quan_sheng.png`" alt="">
          <img v-if="couponData.marking === 'cou'" class="value-tag-quan" :src="`${$cdnImageUrl}/goodsDetail/quan_cou.png`" alt="">
          <img class="value-label-bg" :src="`${$cdnImageUrl}/voucher/coupon_left.png`" alt="">
          <!-- <span class="val-icon">￥</span>
          <span class="val-num" :class="{bigVal:isBigVal}">{{couponData.couponValue}}</span> -->
        </div>
        <div class="info-wrapper">
          <div class="info-body">
            <coupon-right :couponData="couponData" v-if="couponData.couponType==='REALITY_GIFT_COUPON'"/>
            <div class="info" v-else>
              <p class="info-text">
                <span v-if="couponData.scope==='PRODUCT'" class="singleItem">单品</span>
                <span v-if="couponData.scope==='ORDER'" class="singleItem">订单</span>
                {{couponData.description}}
              </p>
              <p class="info-text">{{couponData.couponTemplateName}}</p>
              <p class="info-text" v-if="couponData.startTime">{{couponData.startTime.replace(/-/g, '.') | formatDateEndOfDay}} - {{couponData.endTime.replace(/-/g, '.') | formatDateEndOfDay}}</p>
              <p class="info-text" v-else>{{couponData.validityPeriod}}</p>
            </div>
            <div class="receive">
              <div v-if="couponData.displayType==='1'" class="not-received">
                <span class="receive-btn" @click="receive">点击领取</span>
              </div>
              <div v-if="couponData.displayType==='2'">
                <!-- 已使用 -->
                <div v-if="couponData.couponFinishUsingType==='1'" class="used">
                  <img :src="`${$cdnImageUrl}/voucher/used_sub.png`">
                </div>
                <div v-else class="received">
                  <img :src="`${$cdnImageUrl}/goodsDetail/received.png`" alt="">
                </div>
              </div>
              <div v-if="couponData.displayType==='5'" class="sold-out">
                <img :src="`${$cdnImageUrl}/voucher/voucher-center-yiqiangguang.svg`" class="sold-out-img">
              </div>
            </div>
          </div>
          <img class="info-warp-bg" :src="`${$cdnImageUrl}/voucher/coupon_right.png`" alt="">
          <div @click="showRules" class="gift-info" v-if="couponData.couponType === 'REALITY_GIFT_COUPON'">礼品信息<img alt mode="widthFix" :src="`${$cdnImageUrl}/shop/icon_round_arrow_new_${giftListVisible?'down.png':'up.png'}`" /></div>
          <div @click="showRules" class="gift-info" v-else>使用规则<img alt mode="widthFix" :src="`${$cdnImageUrl}/shop/icon_round_arrow_new_${giftListVisible?'down.png':'up.png'}`" /></div>
        </div>
      </div>

      <!-- <img class="type-icon" :src="iconSrc" alt="">
      <img class="new-coupon-bg" :src="`${$cdnImageUrl}/shop/yhq-new-coupon-bg.png`" /> -->
    </div>
    <div class="rules-container" v-show="giftListVisible && (giftRuleList.length || rules.length || couponMarketRule)">
      <!-- 券规则 -->
      <div class="rules" v-if="couponMarketRule || rules.length">
        <div class="gift-title">使用条件</div>
        <!-- 营销中台规则 -->
        <div v-if="couponMarketRule">
          <div>规则一</div>
          <div>{{ couponMarketRule }}</div>
        </div>
        <!-- 策略中台规则 -->
        <div v-if="rules.length" class="rulesContainer">
          <div>{{ rules.length && couponMarketRule ? '规则二' : '规则一' }}</div>
          <div class="rule" v-for="(rule, index) in rules" :key="index">
            <!-- 产品明细 -->
            <p v-if="rule.type === 'products'">
              <span>{{ rulesIndex[index] }}</span>
              <span>订单中需要包含以下商品</span>
              <span v-for="(item, idx) in rule.list" :key="idx">
                <span style="color: red" v-if="idx >= 1">{{ item.setRelationShip === 1 ? '或' : '且' }}</span>
                <span style="font-weight: 800; padding: 0 5px">{{ item.productName }}{{ `(${item.productCode})` }}</span>
              </span>
            </p>
            <p v-else>
              {{ rulesIndex[index] }}{{ rule.text }}
            </p>
          </div>
        </div>
      </div>
      <div class="rules">
        <div class="gift-title" v-if="giftRuleList && giftRuleList.length>0">赠品信息</div>
        <div class="" v-for="(rule, index) in giftRuleList" :key="index">
          <div class="">满{{rule.amount}}元赠送</div>
          <div class="" v-for="(gift, giftIndex) in rule.giftList" :key="giftIndex">
            <div class="" v-if="rule.giftList.length>1">礼品{{giftIndex + 1}}</div>
            <div class="">{{gift.giftName}}-{{gift.giftQuantity}}件</div>
          </div>
        </div>
      </div>
      
    </div>
   
  </div>
</template>

<script>
import couponValueLabel from '@/components/couponValueLabel'
import couponRight from '@/components/coupon/couponRight.vue'
import { getCouponMarketAndStrategyRule } from '@/http/service/usablecouponlist'

export default {
  components: { couponValueLabel, couponRight },
  props: {
    couponData: Object
  },
  data () {
    return {
      giftListVisible: false,
      couponMarketRule: '',
      rules: [],
      rulesIndex: {
        0: '①',
        1: '②',
        2: '③',
        3: '④',
      },
    }
  },
  created () {},
  mounted () {},
  beforeDestroy () {},
  methods: {
    showRules(){
      this.giftListVisible = !this.giftListVisible

      if (!this.giftListVisible) return
      getCouponMarketAndStrategyRule({
        couponTemplateCode: this.couponData?.couponTemplateCode,
        couponCode: this.couponData?.couponCode,
        sourceChannel: this.couponData?.sourceChannel,
        activityCode: this.couponData?.activityCode,
        platformChannel: this.couponData?.platformChannel,
      }).then(res => {
        if (res?.data?.data) {
          // this.couponRuleList = res.data.data
          this.couponMarketRule = res.data.data.couponMarketRule
          this.rules = this.$util.formateRules(res.data.data.couponStrategyRule, false)
        }
      })
    },
    receive () {
      this.$util.gioTrackWithVariable('MB15621', {
        ad_coupon_id: this.couponData.couponTemplateCode ? this.couponData.couponTemplateCode + '' : 'null'
      })
      console.log('this.couponData', this.couponData)
      const time = {
        startTime: this.couponData.startTime ? this.couponData.startTime.split(' ')[0] : '',
        endTime: this.couponData.endTime ? this.couponData.endTime.split(' ')[0] : ''
      }
      this.$emit('receive', time)
    }
  },
  computed: {
    giftRule() {
      return this.couponData.giftRule ? this.couponData.giftRule : []
    },
    giftRuleList() {
      if (!this.giftListVisible) return []
      return this.giftRule
    },

    isBigVal () {
      return this.couponData.couponValue > 1000
    },
    couponIcon () {
      const _couponIcon = {
        ORDER: `${this.$cdnImageUrl}/shop/icon-coupon-card.png`,
        SCENE: `${this.$cdnImageUrl}/shop/icon-coupon-scene.png`,
        // ORDER: `${this.$cdnImageUrl}/shop/icon-coupon-plat.png`,
        SHOP: `${this.$cdnImageUrl}/shop/icon-coupon-shop.png`
      }
      return _couponIcon
    },
    iconSrc () {
      let type = this.couponData.couponUseType

      if (this.couponData.applyType) type = 'SCENE'

      return this.couponIcon[type] || type
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.coupon-item {
  position: relative;
  width: 100%;
  filter: drop-shadow(0px 2px 2px rgba(196,60,60,0.15));
}
.rules-container {
  display: flex;
  flex-direction: column;
  padding: 0.24rem;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 0px 0px 12px 12px;
  border-top: none;
  position: relative;
  top: -0.2rem;
  .rules {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.24rem;
    color: rgba(0,0,0,.39);
    line-height: 0.4rem;
  }
}
.gift-title {
  background-image: linear-gradient(90deg, rgba(255,142,99,0.15) 0%, rgba(255,75,81,0.15) 100%);
  border: 0.5px solid #FF2626;
  font-size: 0.22rem;
  padding: 0.09rem 0.16rem;
  line-height: 0.22rem;
  border-radius: 0.2rem;
  width: auto;
  color: #F05345;
  margin-top: 0.16rem;
  margin-bottom: 0.08rem;
  font-weight: bold;
}
.content-wrapper {
  display: flex;
  height: 2.05rem;
  border-radius: .16rem;
  overflow: hidden;
  .value-wrapper ,.info-wrapper {
    display: inline-block;
    vertical-align: top;
  }
}

.value-wrapper {
  position: relative;
  width: 2.08rem;
  height: 2.05rem;
  font-size: 0.32rem;
  color:#fff;
  text-align: center;
  .val-icon, .val-num {
    position: relative;
    left: -0.12rem;
    line-height: 1.8rem;
  }
  .val-num {
    font-size:0.72rem;
    font-weight: bold;
    &.bigVal {
      font-size: 0.56rem;
    }
  }
  .value-label{
    position: absolute;
    top: 0;
    left: 0;
    width: 2.08rem;
    height: 2.05rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2;
    .container{
      height: auto;
    }
  }
  .value-tag{
    position: absolute;
    top: .18rem;
    left: -1px;
    width: .9rem;
    height: .32rem;
    z-index: 2;
  }
  .value-tag-quan{
    position: absolute;
    bottom: 0;
    left: 0;
    width: .46rem;
    height: .45rem;
    z-index: 2;
  }

  .value-tag-small{
    width: .68rem;
  }
  .value-tag-pingtai{
    width: .9rem;
  }
  .value-tag-gift{
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .value-tag-gift-label{
    background: linear-gradient(270deg, rgba(154,79,240,1) 0%, rgba(107,74,239,1) 100%);
    font-size: 12px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 10px;
    span {
      transform: scale(0.95);
    }
  }
  .value-label-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 2.08rem;
    height: 2.05rem;
    z-index: 1;
  }
  .value-tips{
    font-size: .22rem;
  }
}
.info-wrapper {
  position: relative;
  width: 4.78rem;
  .info, .receive {
    display: inline-block;
      vertical-align: top;
  }
  .info-body{
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 3.2rem;
    height: 2.05rem;
    padding: 0.3rem 0 0.3rem 0.32rem;
    box-sizing: border-box;
    .info-text {
      font-size: 0.24rem;
      color:#333333;
      line-height: 0.4rem;
    }
    .singleItem{
      color: $themeSynRed;
      margin-right: 0.06rem;
    }
  }
  .receive {
    display: flex;
    justify-items: center;
    align-items: center;
    width: 1.58rem;
    height: 2.05rem;
    padding: 0 0.16rem;
    box-sizing: border-box;
    .not-received, .received {
      vertical-align: middle;
      height: 2.05rem;
    }
    .receive-btn, .receive-disabled {
      // font-size: 0.28rem;
      // line-height: 0.44rem;
      vertical-align: middle;
      font-size: 0.24rem;
      line-height: 0.32rem;
    }
    .not-received {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 1.44rem;
      height: .48rem;
      background: linear-gradient(270deg,#ff5555 0%, #ff9042 100%);
      border-radius: .32rem;
      color: white;
      font-size: .24rem;
    }
    .received {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      width: 1.32rem;
      height: 1.16rem;
      > img{
        width: 100%;
        height: 100%;
      }
    }
    .used{
      position: absolute;
      right: -.44rem;
      bottom: -.37rem;
      z-index: 2;
      width: 1.75rem;
      height: 1.55rem;
      transform:rotate(7deg);
      > img{
        width: 100%;
        height: 100%;
      }
    }
    .sold-out {
      .sold-out-img {
        width: 1.14rem;
        height: .92rem;
      }
    }
  }
  .gift-info {
    z-index: 99;
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 70px;
    height: 20px;
    font-size: 12px;
    color: #999;
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      width: 0.24rem;
      &.active {
        transform: rotate(90deg);
      }
    }
  }
}

.info-warp-bg{
  position: absolute;
  top: 0;
  left: 0;
  width: 4.78rem;
  height: 2.05rem;
  z-index: 1;
}

.type-icon {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0.14rem;
  height: 0.36rem;
}
.new-coupon-bg {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  width: 100%;
  // height: 1.8rem;
}

.gift-rule-list {
  padding: 0px 8px 4px 8px;
  font-size: 12px;
  background-color: #f5f5f5;
  .gift-rule {
    color: #FF5252;
    margin-bottom: 5px;
    background-color: rgba(255, 82, 82, 0.15);
    border-radius: 20px;
    display: inline-block;
    padding: 2px 6px;
  }
  .gift-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 6px;
    .gift-item-label {
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      background-color: #FF6767;
      color: #fff;
      width: 46px;
      height: 18px;
      border-radius: 4px;
      margin-right: 5px;
    }
    .gift-item-name {
      color: #333;
    }
    
  }
}
.coupon-item+.gift-rule-list {
  margin-top: -20px;
  padding-top: 30px;
}
.gift-rule-list:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
